import MembersAuth0, { IMembersAuth0ApiModel } from '@models/MemberAuth0';
import { api } from '@services';
import { sortStr } from '@utils/sorting/non-ascii';

export interface IUserMember {
  id: string;
  name: string;
  picture: string;
  email: string;
}

const getUserMembers = async (): Promise<IUserMember[]> => {
  const { data: usersFull } = await api.get<IMembersAuth0ApiModel[]>(
    '/auth0/userMembers',
  );
  const _usersFull = MembersAuth0.arrayFromApiModel(usersFull);
  return _usersFull.sort((a, b) => sortStr(a.name, b.name));
};

export { getUserMembers };
